module.exports = __webpack_public_path__ + "img/president-portrait.b3ce303b.jpg";